"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("./ConditionalHelper");
var replacePlaceholders_1 = require("../utils/replacePlaceholders");
var RedirectHelper = /** @class */ (function () {
    function RedirectHelper(url, base) {
        if (!base) {
            base = window && window.location.origin;
        }
        this.url = new URL(url, base);
    }
    RedirectHelper.prototype.go = function (redirect, inputs) {
        var options = redirect.options;
        var redirectPath = this.getRedirectPath(redirect, inputs);
        if (redirectPath) {
            if (options && options.target) {
                window.open(redirectPath, options.target);
            }
            else {
                document.location.href = redirectPath;
            }
        }
    };
    RedirectHelper.prototype.getRedirectPath = function (redirect, inputs) {
        if (redirect) {
            var conditionalRedirects = redirect.conditionalRedirects, defaultUrl = redirect.defaultUrl, _a = redirect.options, options = _a === void 0 ? {} : _a;
            var validRedirect = void 0;
            if (conditionalRedirects) {
                validRedirect = conditionalRedirects.find(function (conditionalRedirect) {
                    var conditional = conditionalRedirect.conditional;
                    var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional);
                    return conditionalHelper.matches(inputs);
                });
            }
            var url = (validRedirect && validRedirect.url) || defaultUrl;
            var redirectOptions = (validRedirect && validRedirect.options) || options;
            var replacedUrl = replacePlaceholders_1.replacePlaceholders(inputs || {}, url);
            return this.getRedirectUrl(replacedUrl, redirectOptions);
        }
    };
    RedirectHelper.prototype.getRedirectUrl = function (redirectString, options) {
        var redirectUrl = new URL(redirectString, window && window.location.origin); // if url is absolute, base is ignored
        if (options.preserveOriginPath) {
            var redirectUrlSegments = redirectUrl.pathname.split('/');
            var currentUrlSegments = this.url.pathname.split('/');
            var mergedSegments_1 = __spreadArrays(currentUrlSegments, redirectUrlSegments);
            var reducedSegments = mergedSegments_1.reduce(function (segments, segment, segmentIndex) {
                if (segmentIndex === 0 || segmentIndex > 0 && mergedSegments_1[segmentIndex - 1] !== segment) {
                    segments.push(segment);
                }
                return segments;
            }, []);
            redirectUrl.pathname = reducedSegments.join('/');
        }
        if (options.preserveOriginHash) {
            redirectUrl.hash = this.url.hash;
        }
        if (options.preserveOriginQueryString) {
            this.url.searchParams.forEach(function (value, key) {
                if (!redirectUrl.searchParams.has(key)) {
                    redirectUrl.searchParams.set(key, value);
                }
            });
        }
        return redirectUrl.toString();
    };
    return RedirectHelper;
}());
exports.RedirectHelper = RedirectHelper;
//# sourceMappingURL=RedirectHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/helpers/RedirectHelper.js
// module id = 757
// module chunks = 1